<div class="{{orientationVertical?'cnt-column':'cnt-row'}}">

    <div *ngFor="let item of items" 
         class="{{orientationVertical?'cnt-column':'cnt-row'}} {{item.getInputValue() == value && !disabled ? 'selected-item' : ''}} {{disabled ? 'disabled-item' : ''}}" 
         (click)="onSelect(item)"
         (mouseenter)="onItemEnter($event, item)" 
         (mouseleave)="onItemLeave($event, item)">

        <div class="cnt-row-centered" (click)="onSelect(item)">
            <div class="{{imgClass(item)}}"
                 attr.data-testid="{{item.testId}}-rb-item-input">
            </div>
            <div [width]="labelSpace"></div>
            <div class="itemtext h4Font g5Color {{colorClass(item)}}" attr.data-testid="{{item.testId}}-rb-item-label">{{item.label}}</div>
        </div>
        <div *ngIf="!isLast(item)" [width]="(!orientationVertical)?itemSpace:0" [height]="orientationVertical?itemSpace:0"></div>

    </div>

</div>